<ejs-dialog #modal [isModal]='true' 
    [header]="'Reativar Doença'" 
    [target]="'body'"
    [visible]="false"
    width="800px"
    [ngClass]="{ 'em-operacao': emOperacao }"
    height="640px"
    (open)="modalOk=true"
    (close)="modalOk=false"
    [showCloseIcon]='true' id="reativar-doenca-modal"
    (beforeClose)="fechandoModal($event)"
    [closeOnEscape]='true'>

    <ng-template #content>
        <ejs-tab  #tab class='e-fill'>
            <div class="e-tab-header">
                <div>Informações Gerais</div>
            </div>
            <div class="e-content">
                <div class="" style="padding: 15px">
                    <form [formGroup]='modelo' [ngClass]="{'submitted': submetido}">
                        <div class='row' style="width: 100%">
                            <div class='col-xs-12 form-group' required>
                                <ax-select [placeholder]="'CID10'" [dataSource]="dsCids10"
                                appendTo='#reativar-doenca-modal'
                                [enabled]="false"
                                [formControlName]="'cid10Codigo'" [label]="'CID10'"></ax-select>
                                <app-error-handler [control]="modelo.get('cid10Codigo')" [submitted]='submetido'
                                [errorType]="'required'">
                                </app-error-handler>
                            </div>
                            <div class='col-xs-12 form-group'>
                                <ejs-datepicker formControlName="dataAtendimento" [placeholder]="'Data Atendimento'" 
                                [enabled]="false"
                                [floatLabelType]="'Always'"></ejs-datepicker>    
                            </div>
                        </div>

                        <div class='row' style="width: 100%">
                            <div class='col-xs-12 form-group' *ngIf="modalOk">
                                <app-texto-editor height="250px"
                                [label]="'Descrição sobre a reativação da doença...'"
                                [textoResete]='ultimaDescricao' [formControlName]="'descricao'"></app-texto-editor>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </ejs-tab>
    
    
    </ng-template>
    
    <ng-template #footerTemplate>
        <button  ejs-button  class=" e-btn e-primary" data-ripple="true" appDebounceClick
        [iconCss]="'fas fa-save'"
        (click)='reativar()'>Reativar</button>
        <button ejs-button  class="e-btn " data-ripple="true" (click)='cancelar()'>Cancelar</button>
    </ng-template>

</ejs-dialog>


